import React, { useCallback, useEffect, useState } from 'react';
import OpenKnotsLoginFooter from 'components/openKnotsLogin/OpenKnotsLoginFooter';
import OpenKnotsLoginHero from 'components/openKnotsLogin/OpenKnotsLoginHero';
import '../OpenKnotsLogin.css';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import OpenKnotsResetPasswordComponent from 'components/openKnotsLogin/OpenKnotsResetPasswordComponent';

const ResetPasswordError = () => (
    <div className='opk-login-panel'>
        <div className='opk-login-card'>
            <h3>Something went wrong!</h3>
        </div>
    </div>
);

const ResetPasswordPanel = ({ code, isEmailReceived, payload, locationState }) => {
    if (!code) {
        if (!locationState) {
            return <ResetPasswordError />;
        }
        return <OpenKnotsResetPasswordComponent payload={locationState} />;
    }
    if (isEmailReceived) {
        return <OpenKnotsResetPasswordComponent payload={payload} />;
    }
    return <ResetPasswordError />;
};

function OpenKnotsResetPassword() {
    const baseUrlAuth = process.env.REACT_APP_AUTH_MANAGEMENT;
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');

    const [payload, setPayload] = useState({
        userName: '',
        type: 'resetPassword',
    });
    const [isEmailReceived, setIsEmailReceived] = useState(true);

    const getEmailByHash = useCallback(() => {
        if (code) {
            axios
                .get(`${baseUrlAuth}/getEmailByHash?code=${code}`)
                .then((res) => {
                    if (res.status === 200) {
                        setPayload((prevPayload) => ({
                            ...prevPayload,
                            userName: res.data,
                        }));
                    } else {
                        setIsEmailReceived(false);
                    }
                })
                .catch(() => {
                    setIsEmailReceived(false);
                });
        }
    }, [code, baseUrlAuth]);

    useEffect(() => {
        if (code) {
            getEmailByHash();
        }
    }, [getEmailByHash, code]);

    const location = useLocation();

    return (
        <div className='opk-login align-items-start'>
            <OpenKnotsLoginHero />
            <ResetPasswordPanel
                code={code}
                isEmailReceived={isEmailReceived}
                payload={payload}
                locationState={location.state}
            />
            <OpenKnotsLoginFooter />
        </div>
    );
}

export default OpenKnotsResetPassword;
